import msCategoriesQuery from "web/queries/ms/categoriesByIds.graphql";

import MapWrapper from "web/utils/system/storage/storagesAsync/mapWrapper";

import { rootCategoriesIds } from "web/constants/categories";

import { ICategory } from "web/types/Category";

import {
  addCategoryEntries,
  removeCategoryEntries,
  selectEntities,
} from "../categories/categoriesSlice";
import useDataCached from "./useDataCached";

const mapData = new MapWrapper();

const useDataCachedCategories = ({ ids }: { ids: number[] }) =>
  useDataCached<ICategory>({
    ids: ids.filter((id) => !rootCategoriesIds.includes(+id)).map(id => +id),
    query: msCategoriesQuery,
    addToCacheAction: addCategoryEntries,
    removeFromCacheAction: removeCategoryEntries,
    selectEntities,
    mapData,
  });

export default useDataCachedCategories;
